import { useNavigationProgress } from "../hooks/use-navigation-progress.hook";

type NavigationProgressBarProps = {
  height?: number;
  color?: string;
  showShimmer?: boolean;
};

export const NavigationProgressBar = ({
  height = 3,
  color = "from-blue-500 via-purple-500 to-pink-500",
  showShimmer = true,
}: NavigationProgressBarProps) => {
  const { isNavigating, progress, isComplete } = useNavigationProgress();

  if (!isNavigating && !isComplete) return null;

  return (
    <div
      className="fixed start-0 top-0 z-[9999] w-full bg-transparent"
      style={{ height: `${height}px` }}
    >
      <div
        className={`h-full bg-gradient-to-r ${color} shadow-lg transition-all duration-300 ease-out`}
        style={{
          width: `${progress}%`,
          transform: isComplete ? "scaleX(1)" : "scaleX(1)",
          transformOrigin: "start",
        }}
      >
        {/* Add a subtle glow effect */}
        <div className="h-full w-full bg-white/20 blur-sm" />
      </div>

      {/* Add a subtle shimmer effect */}
      {isNavigating && showShimmer && (
        <div
          className="absolute top-0 h-full w-8 bg-gradient-to-r from-transparent via-white/30 to-transparent"
          style={{
            left: `${Math.max(0, progress - 4)}%`,
            animation: "shimmer 1.5s infinite",
          }}
        />
      )}
    </div>
  );
};
